import { typography } from '@shared/tokens/typography.stylex';
import { anatomy } from '@shared/tokens/anatomy.stylex';
import { palette } from '@shared/tokens/palette.stylex';
import { colors } from '@shared/tokens/colors.stylex';
import { fonts } from '@shared/tokens/fonts.stylex';
import * as stylex from '@stylexjs/stylex';

export const styles = stylex.create({
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: anatomy['space-12'],
    alignItems: 'flex-start',
  },
  titleContainer: {
    ':not(#__unused__) > button': {
      cursor: 'pointer',
      display: 'inline !important',
      marginLeft: '8px',
    },
  },
  titleHidden: {
    display: 'none',
  },
  title: {
    cursor: 'text',
    display: 'inline',
    background: 'transparent',
    border: 'none',
    outline: 'none',
    padding: 0,
    fontFamily: fonts.din2014Demi,
    fontSize: typography['fontSizeBody-3'],
    lineHeight: typography['lineHeightBody-3'],
    color: palette['greyWhite'],
    wordBreak: 'break-word',
  },
  titleDisable: {
    color: colors.secondaryBackground,
    cursor: 'grab',
  },
  changeVisibleButtonDisable: {
    color: colors.secondaryBackground,
    ':hover': {
      color: colors.accentIcon,
    },
  },
  changeVisibleButton: {
    color: colors.accentIcon,
    display: 'inline',
    alignItems: 'center',
  },
  items: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: anatomy['space-16'],
    ':not(#__unused__) > button': {
      alignSelf: 'flex-start',
    },
  },
  checkbox: {
    width: '100%',
    display: 'flex',
    gap: anatomy['space-8'],
    alignItems: 'flex-start',
    fontSize: typography['fontSizeCaption-1'],
    lineHeight: typography['lineHeightCaption-1'],
    color: palette['grey-500'],
    ':not(#__unused__) input:not(:checked)::before': {
      borderColor: `${palette['lighted-20']} !important`,
    },
    ':not(#__unused__) > input:checked::before': {
      backgroundImage:
        "url(\"data:image/svg+xml,%3Csvg width='10' height='8' viewBox='0 0 10 8' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M8.75 1.5L4.79542 6.81817C4.65906 7.0909 4.38633 7.22725 4.1136 7.22725C3.84088 7.22725 3.56818 7.09091 3.29545 6.95454L1.25 4.90909' stroke='rgb(29, 37, 45)' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E%0A\") !important",
    },
    ':not(#__unused__) input': {
      alignSelf: 'flex-start',
      marginTop: 1,
    },
    ':hover > div:last-child': {
      visibility: 'visible',
    },
  },
  radioButton: {
    width: '100%',
    display: 'flex',
    gap: anatomy['space-8'],
    alignItems: 'flex-start',
    fontSize: typography['fontSizeCaption-1'],
    lineHeight: typography['lineHeightCaption-1'],
    color: palette['grey-500'],
    ':not(#__unused__) input[type="radio"]': {
      background: 'transparent !important',
    },
    ':not(#__unused__) input[type="radio"]:not(:checked)': {
      borderColor: `${palette['lighted-20']} `,
    },
    ':not(#__unused__) input': {
      alignSelf: 'flex-start',
      marginTop: 1,
      minWidth: anatomy['space-16'],
    },
    ':hover > div:last-child': {
      visibility: 'visible',
    },
  },
  optionError: {
    ':not(#__unused__) input:not(:checked)::before': {
      borderColor: `${colors.errorBorder} !important`,
    },
  },
  addButton: {
    width: '100%',
  },
  tiptapContainer: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: anatomy['space-4'],
  },
  text: {
    width: '100%',
    fontSize: typography['fontSizeCaption-1'],
    lineHeight: typography['lineHeightCaption-1'],
    color: palette['grey-500'],
    ':not(#__unused__) > div': {
      outline: 'none !important',
    },
    ':not(#__unused__) a': {
      color: colors.accentText,
    },
  },
  error: {
    fontSize: typography['fontSizeCaption-2'],
    lineHeight: anatomy['space-12'],
    color: colors.errorText,
  },
  actions: {
    display: 'flex',
    gap: anatomy['size-12'],
    alignItems: 'center',
    alignSelf: 'flex-start',
    visibility: 'hidden',
  },
  moveButton: {
    display: 'flex',
    cursor: 'grab',
  },
  removeButton: {
    display: 'flex',
    padding: anatomy['size-4'],
    background: colors.accentBackground,
    borderRadius: anatomy.borderRadiusXs,
  },
  errorContainer: {
    display: 'flex',
    gap: anatomy['size-8'],
    padding: `${anatomy['size-8']} ${anatomy['size-16']}`,
    background: colors.errorBackground,
    borderRadius: anatomy.borderRadiusS,
  },
  errorText: {
    fontSize: typography['fontSizeCaption-1'],
    lineHeight: typography['lineHeightCaption-1'],
  },
});
